export default __webpack_public_path__ + "static/media/1.53b5cb18.png";